import {
  Github,
  Gmail,
  GoogleCalendar,
  Linkedin,
  Slack,
} from "@arcadeai/design-system/components/ui/atoms/icons";

export type SuggestedAction = {
  id: string;
  icon: React.ReactNode;
  title: string;
  subtitle: string;
  action: string;
};

export const DEFAULT_CHAT_SUGGESTED_ACTIONS: SuggestedAction[] = [
  {
    id: "gmail",
    icon: <Gmail className="size-4 sm:size-5" />,
    title: "Read my emails",
    subtitle: "and summarize them",
    action:
      "Read the last 3 emails from my google account and tell me about them",
  },
  {
    id: "slack",
    icon: <Slack className="size-4 sm:size-5" />,
    title: "Check Slack messages",
    subtitle: "in the #general channel",
    action: "Check the last 10 Slack messages in the #general channel",
  },
  {
    id: "github",
    icon: <Github className="size-4 sm:size-5" />,
    title: "Star the arcadeai/arcade-mcp",
    subtitle: "repo on GitHub",
    action: "Star the arcadeai/arcade-mcp repo on GitHub",
  },
  {
    id: "linkedin",
    icon: <Linkedin className="size-4 sm:size-5" />,
    title: "Publish a new post on LinkedIn",
    subtitle: "saying that I'm testing Arcade.dev",
    action: 'Publish a new post on LinkedIn saying "Arcade.dev is awesome!"',
  },
  {
    id: "google-calendar",
    icon: <GoogleCalendar className="size-4 sm:size-5" />,
    title: "Check my schedule",
    subtitle: "for today on Google Calendar",
    action: "What events do I have on my Google Calendar today?",
  },
];
